import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-57">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-58">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-2xl" data-id="element-59">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-forest leading-[1.1] mb-6" data-id="element-60">
              Tu perro no puede pedir ayuda, pero sus rascados constantes son un
              grito de auxilio.
            </h1>

            <h2 className="text-xl md:text-2xl text-rust-600 font-serif mb-8 leading-snug" data-id="element-61">
              Detén el ciclo de picor, llagas y desesperación de tu mascota en
              14 días (o menos) sin fármacos costosos ni efectos secundarios.
            </h2>

            <div className="space-y-4 text-lg text-charcoal-500 mb-10" data-id="element-62">
              <p data-id="element-63">
                Si has llegado aquí, es porque sabes exactamente qué se siente
                al escuchar ese sonido rítmico a las 3 de la mañana: tu perro
                rascándose contra la pared, lamiendo sus patas sin parar o
                gimiendo por la irritación.
              </p>
              <p data-id="element-64">
                Vives con la frustración de ver su piel roja, caliente y con mal
                olor, sabiendo que las inyecciones y pastillas del veterinario
                solo duran un par de semanas antes de que el "infierno del
                rascado" regrese con más fuerza.
              </p>
            </div>

            <Button href="#comprar" showTrust className="w-full sm:w-auto" data-id="element-65">
              ¡SÍ, QUIERO QUE MI PERRO DEJE DE SUFRIR!
            </Button>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-66">
            <div className="aspect-[4/5] md:aspect-square rounded-2xl overflow-hidden shadow-2xl relative" data-id="element-67">
              <div className="absolute inset-0 bg-forest/10 mix-blend-multiply z-10 rounded-2xl" data-id="element-68"></div>
              <img src="https://images.unsplash.com/photo-1543466835-00a7907e9de1?q=80&w=2574&auto=format&fit=crop" alt="Perro descansando con mirada triste" className="w-full h-full object-cover" data-id="element-69" />
            </div>
            {/* Decorative element */}
            <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-rust/10 rounded-full blur-3xl -z-10" data-id="element-70"></div>
            <div className="absolute -top-6 -right-6 w-64 h-64 bg-forest/10 rounded-full blur-3xl -z-10" data-id="element-71"></div>
          </motion.div>
        </div>
      </div>
    </section>;
}